import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const stats = [
  { k: "120+", v: "Kurumsal Müşteri" },
  { k: "81", v: "İlde Faaliyet" },
  { k: "850+", v: "Tamamlanan Proje" },
  { k: "%99.6", v: "Müşteri Memnuniyeti" },
];

const testimonials = [
  {
    name: "Mehmet Yıldırım",
    role: "Proje Müdürü, Anadolu Yapı A.Ş.",
    text: "10 yılı aşkın süredir İnci Tel ile çalışıyoruz. Kaliteleri ve teslimat hızları sektörün üzerinde.",
  },
  {
    name: "Selin Kaya",
    role: "Satınalma Müdürü, EnerjiNet",
    text: "Bakır iletken siparişlerimizde standartlara tam uyum ve sertifikalı süreç bizim için kritik. İnci Tel her zaman beklentinin üzerinde.",
  },
  {
    name: "Hasan Demir",
    role: "Kurucu, DemirTarım Hayvancılık",
    text: "Geniş çiftlik alanlarımız için çit sistemleri kurduk. Dayanıklılık ve montaj kolaylığı açısından çok memnunuz.",
  },
];

const partnerImages = [
  "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/7ya78s9f_IMG-20260610-WA0008.jpg",
  "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/13tvo0d6_IMG-20260610-WA0006.jpg",
  "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/u9ktfxaw_IMG-20260610-WA0005.jpg",
  "https://customer-assets.emergentagent.com/job_telecom-pro-6/artifacts/q3it63e5_IMG-20260610-WA0009.jpg",
];

export default function References() {
  return (
    <section
      id="referanslar"
      data-testid="references-section"
      className="bg-white py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FF5A00]/10 text-[#FF5A00] font-mono-disp text-[11px] font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF5A00]" />
            Referanslarımız
          </div>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tighter text-gray-900 leading-[1.02]">
            Önde gelen{" "}
            <span className="font-serif-disp font-normal text-[#FF5A00]">
              kurumlar
            </span>{" "}
            tercih ediyor
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s) => (
            <div
              key={s.k}
              className="card-mod px-5 py-7 flex flex-col items-center text-center"
            >
              <div className="font-display text-4xl sm:text-5xl text-gray-900 font-bold tracking-tighter">
                {s.k}
              </div>
              <div className="font-body text-sm text-gray-500 mt-2">{s.v}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {partnerImages.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="aspect-square overflow-hidden rounded-2xl bg-gray-100 border border-gray-100"
            >
              <img
                src={src}
                alt={`Referans ${i + 1}`}
                className="w-full h-full object-cover grayscale hover:grayscale-0 hover:scale-105 transition-all duration-500"
              />
            </motion.div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${idx}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="card-mod p-7 flex flex-col gap-4"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#FF5A00] text-[#FF5A00]" />
                  ))}
                </div>
                <Quote className="w-6 h-6 text-gray-200" />
              </div>
              <p className="font-body text-base text-gray-700 leading-relaxed flex-1">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="border-t border-gray-100 pt-4">
                <div className="font-display text-base font-semibold tracking-tight text-gray-900">
                  {t.name}
                </div>
                <div className="font-mono-disp text-[11px] text-gray-500 mt-1">
                  {t.role}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
